import { render, staticRenderFns } from "./bidRequire.vue?vue&type=template&id=5921825a&scoped=true&lang=pug"
import script from "./bidRequire.vue?vue&type=script&lang=js"
export * from "./bidRequire.vue?vue&type=script&lang=js"
import style0 from "./bidRequire.vue?vue&type=style&index=0&id=5921825a&prod&lang=scss&scoped=true"
import style1 from "./bidRequire.vue?vue&type=style&index=1&id=5921825a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5921825a",
  null
  
)

export default component.exports